<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div>
          <div class="row">
            <div class="col-lg-12" v-if="this.session.usuario.perfil == 0">
              <router-link to="/panel_usuarios" class="btn btn-orange rounded-pill">
                <i class="bx bx-chevron-left"></i> Regresar
              </router-link>
            </div>
            <div class="col-lg-6 mt-3">
              <h3 class="text-orange">Usuarios</h3>
            </div>
            <div class="col-lg-6 text-end mt-3 ms-auto">
              <router-link to="/nueva_membresia" class="btn btn-orange btn-lg rounded-pill">
                <i class="bx bxs-plus-circle"></i> Nuevo usuario
              </router-link>
            </div>
            <hr class="mt-3">
          </div>
          <div class="row">
            <div class="col-lg-12"></div>
          </div>
        </div>
      </transition>
      <transition appear name="slide-fade">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-end mb-2">
              <a v-on:click="toggle_filtros()">
                <i class="bx bx-filter-alt"></i>
                <span v-if="mostrar_filtros"> Ocultar filtros</span>
                <span v-if="!mostrar_filtros"> Mostrar filtros</span>
              </a>
            </div>
          </div>
          <div v-if="mostrar_filtros" class="col-lg-12">
            <div class="row">
              <div class="col-lg-5 d-flex align-items-stretch">
                <div class="card card-body">
                  <div class="p-1">
                    <div v-if="loading_chart" class="text-center">
                      Cargando...
                    </div>
                    <div v-else>
                      <apexchart type="bar" :options="chart.options" :series="chart.series"></apexchart>
                      <div class="text-end mt-2">
                        <h5 class="fw-bold text-orange">
                          {{ total_usuarios }} membresías
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-7 d-flex align-items-stretch">
                <div class="card card-body">
                  <div class="p-4">
                    <div class="row">
                      <div class="form-group col-lg-12">
                        <label>Estado</label>
                        <select v-model="estado" v-on:change="filtrar()" class="form-control">
                          <option value="null">Todos</option>
                          <option value="0">Interesado</option>
                          <option value="1">Pendiente</option>
                          <option value="3">Exitosa</option>
                        </select>
                      </div>
                      <div class="form-group col-lg-12">
                        <label>Agentes</label>
                        <select v-model="agente" v-on:change="filtrar()" class="form-control">
                          <option value="null">Todos</option>
                          <option :value="agente" v-for="(agente, index_agente) in agentes" v-bind:key="index_agente">{{
                            agente.nombre_completo }}</option>
                        </select>
                      </div>
                      <div class="form-group col-lg-12">
                        <label>Tipo de membresia</label>
                        <select v-model="tipo_membresia" v-on:change="filtrar()" class="form-control">
                          <option value="null">Todos</option>
                          <option value="1">Anual</option>
                          <option value="2">Semestral</option>
                        </select>
                      </div>
                      <div class="form-group col-lg-12">
                        <label>Tipo de usuario</label>
                        <select v-model="tipo_usuario" v-on:change="filtrar()" class="form-control">
                          <option value="null">Todos</option>
                          <option value="0">Principal</option>
                          <option value="1">Beneficiario</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition appear name="slide-fade">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header"></div>
              <div class="card-body">
                <div class="mt-3 mb-3">
                  <label>Buscar</label>
                  <div class="input-group mb-3 shadow border">
                    <span class="input-group-text" id="basic-addon1"><strong><i class="bx bx-search-alt"></i></strong>
                    </span>
                    <input v-on:keyup="get_search" v-model="search" type="text" class="form-control"
                      placeholder="Buscar usuario..." aria-label="Username" aria-describedby="basic-addon1" />
                  </div>
                </div>
                <div v-if="loading_usuarios" class="text-center">
                  <div class="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
                <div v-else>
                  <transition appear name="slide-fade">
                    <div v-if="usuarios.length != 0">
                      <div class="text-end mb-4">
                        <a v-if="vista == 2" v-on:click="toggle_vista(1)">
                          <i class="bx bx-card"></i>
                          Vista ficha
                        </a>
                        <a v-if="vista == 1" v-on:click="toggle_vista(2)">
                          <i class="bx bx-table"></i>
                          Vista tabla
                        </a>
                      </div>
                      <div class="mt-2 mb-3 text-end">
                        <button v-on:click="download" class="btn btn-success rounded-pill">
                          <i class="bx bx-download"></i> Descargar
                        </button>
                      </div>
                      <div v-if="vista == 1">
                        <div v-for="(usuario, index_usuario) in usuarios" v-bind:key="index_usuario"
                          class="card card-body border mb-3">
                          <div class="row">
                            <div class="col-lg-12 mb-2">
                              <span class="fw-bold text-orange me-3" style="font-size: 1em">
                                <i class="bx bx-user"></i>
                                {{ usuario.nombres }} {{ usuario.apellidos }}
                              </span>
                              <span>
                                <span v-if="usuario.estado_registro == 0"
                                  class="badge bg-primary fw-bold">Interesado</span>
                                <span v-if="usuario.estado_registro == 1" class="badge bg-danger fw-bold">Pendiente</span>
                                <span v-if="usuario.estado_registro == 2" class="badge bg-success fw-bold">Completa</span>
                                <span v-if="usuario.estado_registro == 3" class="badge bg-warning fw-bold">Exitosa</span>
                              </span>

                              <hr class="mb-0 mt-1" />
                            </div>

                            <div class="col-lg-3">
                              <span style="font-size: 0.8em">
                                WhatsApp :
                                <strong>{{ usuario.whatsapp }}</strong></span><br />
                              <span style="font-size: 0.8em">
                                Celular :
                                <strong>{{ usuario.celular }}</strong></span>
                            </div>

                            <div class="col-lg-3">
                              <span style="font-size: 0.8em">
                                Correo electrónico : <br />
                                <strong>{{ usuario.email }}</strong></span>
                            </div>
                            <div class="col-lg-12 text-end">
                              <div class="dropdown">
                                <a class="btn btn-outline-primary btn-sm rounded-pill dropdown-toggle"
                                  href="javascript:void(0)" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown"
                                  aria-expanded="false">
                                  Opciones
                                </a>

                                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink">
                                  <li>
                                    <router-link class="dropdown-item" v-bind:to="'/usuario/info_basica/' +
                                      usuario.id_usuario
                                      ">
                                      Editar
                                    </router-link>
                                  </li>
                                  <li>
                                    <router-link class="dropdown-item" v-bind:to="'/beneficiarios/' + usuario.id_usuario
                                      ">
                                      Beneficiarios
                                    </router-link>
                                  </li>
                                  <li>
                                    <router-link class="dropdown-item" v-bind:to="'/pago/' + usuario.id_usuario">
                                      Pago
                                    </router-link>
                                  </li>
                                  <li>
                                    <router-link class="dropdown-item" v-bind:to="'/anexos_membresia/' +
                                      usuario.id_usuario
                                      ">
                                      Soporte de pago
                                    </router-link>
                                  </li>
                                  <li>
                                    <router-link class="dropdown-item" v-bind:to="'/contrato_membresia/' +
                                      usuario.id_usuario
                                      ">
                                      Confirmacion cliente
                                    </router-link>
                                  </li>
                                  <li v-if="session.usuario.perfil == 0">
                                    <a v-on:click="show_modal_eliminar(index_usuario)
                                      " href="javascript:void(0)" class="dropdown-item text-danger">Eliminar</a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="vista == 2">
                        <table class="table table-bordered table-condensed table-hover my_table_1">
                          <thead>
                            <tr>
                              <th style="width: 2%" class="text-center">
                                <a
                                  v-tooltip="'<p>El semaforo funciona con fecha de corte y se<br>muestra dependiendo del tiempo<br>que falta para que se venza<br>la membresia:</p><ul><li>verde  90 a 60 días</li><li>amarillo 60 a 30</li><li>rojo menores a 30 días</li><ul>'">
                                  <i class='bx bx-info-circle'></i>
                                </a>
                              </th>
                              <th style="width: 2%" class="text-center">#</th>
                              <th style="width: 20%">Nombres y apellidos</th>
                              <th class="text-center" style="width: 6%">
                                Estado
                              </th>
                              <th class="text-center" style="width: 10%">
                                Agente
                              </th>
                              <th class="text-center" style="width: 10%">
                                Tipo Membresia
                              </th>
                              <th class="text-center" style="width: 10%">
                                Fecha Corte
                              </th>
                              <th style="width: 10%">Email</th>
                              <th style="width: 10%">WhatsApp</th>
                              <th style="width: 10%">Celular</th>
                              <th style="width: 12%">Dirección</th>
                              <th class="text-center" style="width: 12%">
                                Opciones
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(usuario, index_usuario) in usuarios" v-bind:key="index_usuario">
                              <td class="text-center">
                                <a v-if="usuario.dias_vencimiento < 90" href="javascript:void(0)" v-tooltip="{
                                    content:
                                      'Fecha de Corte: <strong>' +
                                      usuario.fecha_corte +
                                      '</strong><br> Días trascurridos: <strong>' +
                                      usuario.dias_vencimiento +
                                      '</strong>',
                                  }" v-bind:class="{
      'text-success':
        usuario.dias_vencimiento > 60 && usuario.dias_vencimiento < 90,
      'text-warning':
        usuario.dias_vencimiento < 60 && usuario.dias_vencimiento > 30,
      'text-danger': usuario.dias_vencimiento < 30,
    }">
                                  <i class="bx bxs-circle bx-xs"></i>
                                </a>
                              </td>
                              <td class="text-center">{{ usuario.num }}</td>
                              <td class="text-uppercase fw-bold text-orange">
                                {{ usuario.nombres }} {{ usuario.apellidos }}
                              </td>
                              <td class="text-center">
                                <span>
                                  <span v-if="usuario.estado_registro == 0"
                                    class="badge bg-primary fw-bold">Interesado</span>
                                  <span v-if="usuario.estado_registro == 1"
                                    class="badge bg-danger fw-bold">Pendiente</span>
                                  <span v-if="usuario.estado_registro == 2"
                                    class="badge bg-success fw-bold">Completa</span>
                                  <span v-if="usuario.estado_registro == 3"
                                    class="badge bg-warning fw-bold">Exitosa</span>
                                </span>
                              </td>
                              <td>
                                <div v-if="usuario.agente != null">
                                  <span class="text-uppercase">{{
                                    usuario.agente.usuario
                                  }}</span>
                                </div>
                                <small class="text-muted">
                                  {{ usuario.fecha_registro }}
                                </small>
                              </td>
                              <td class="text-center">
                                {{ usuario.membresia.tipo_membresia == 1 ? 'Anual' : 'Semestral' }}
                              </td>
                              <td class="text-center">
                                {{ usuario.fecha_corte }}
                              </td>
                              <td>
                                {{ usuario.email }}
                              </td>
                              <td>{{ usuario.whatsapp }}</td>
                              <td>{{ usuario.celular }}</td>
                              <td>{{ usuario.direccion }}</td>
                              <td class="text-center">
                                <div class="dropdown">
                                  <a class="btn btn-outline-primary btn-sm rounded-pill dropdown-toggle"
                                    href="javascript:void(0)" role="button" id="dropdownMenuLink"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    Opciones
                                  </a>

                                  <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink">
                                    <li>
                                      <router-link class="dropdown-item" v-bind:to="'/usuario/info_basica/' +
                                        usuario.id_usuario
                                        ">
                                        Editar
                                      </router-link>
                                    </li>
                                    <li>
                                      <router-link class="dropdown-item" v-bind:to="'/beneficiarios/' + usuario.id_usuario
                                        ">
                                        Beneficiarios
                                      </router-link>
                                    </li>
                                    <li>
                                      <router-link class="dropdown-item" v-bind:to="'/pago/' + usuario.id_usuario
                                        ">
                                        Pago
                                      </router-link>
                                    </li>
                                    <li>
                                      <router-link class="dropdown-item" v-bind:to="'/anexos_membresia/' +
                                        usuario.id_usuario
                                        ">
                                        Soporte de pago
                                      </router-link>
                                    </li>
                                    <li>
                                      <router-link class="dropdown-item" v-bind:to="'/contrato_membresia/' +
                                        usuario.id_usuario
                                        ">
                                        Confirmacion cliente
                                      </router-link>
                                    </li>
                                    <li v-if="session.usuario.perfil == 0">
                                      <a v-on:click="show_modal_eliminar(index_usuario)
                                        " href="javascript:void(0)" class="dropdown-item text-danger">Eliminar</a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div v-else>
                      <div class="text-muted">
                        <i class="bx bx-info-circle"></i> No se encontraron
                        aliados.
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="mt-4 mb-4" aria-label="Page navigation example" v-html="paginate"></div>
          </div>
        </div>
      </transition>
    </div>
    <modal name="modal_firma_contrato" :adaptive="true" height="350">
      <div class="card m-4">
        <div class="card-header">
          <h4 class="fw-bold text-orange">Solicitar firma de contrato</h4>
        </div>
        <div class="card-body">
          <div v-if="index_select != null">
            <div class="form-group">
              <label>Copiar enlace para compartir con cliente</label>
              <input v-model="usuarios[index_select].url_contrato" type="text" class="form-control" disabled />
            </div>
            <div class="text-center">- ó -</div>
            <div class="text-center mt-3">
              <button v-on:click="send_mail_contrato" class="btn btn-orange rounded-pill">
                Enviar correo a cliente
              </button>
            </div>
          </div>
          <hr />
          <div class="text-end">
            <button @click="$modal.hide('modal_firma_contrato')" class="btn btn-outline-secondary rounded-pill">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal name="modal_eliminar" :adaptive="true" height="250">
      <div class="card m-4">
        <div class="card-header">
          <h4 class="fw-bold text-danger">Eliminar usuario</h4>
        </div>
        <div class="card-body">
          <div v-if="index_select != null" class="text-danger">
            ¿Desea eliminar al usuario
            <strong>{{ usuarios[index_select].nombres }}
              {{ usuarios[index_select].apellidos }}</strong>?
          </div>
          <hr />
          <div class="text-end">
            <button @click="eliminar" class="btn btn-danger rounded-pill">
              Sí
            </button>
            <button @click="$modal.hide('modal_eliminar')" class="btn btn-outline-secondary rounded-pill">
              No
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
export default {
  name: "Usuarios",
  metaInfo: {
    title: "Usuarios - Reddy Backoffice",
  },
  data() {
    return {
      loading: true,
      loading_usuarios: true,
      loading_chart: true,
      page: 1,
      search: null,
      estado: null,
      id_agente: null,
      tipo_membresia: null,
      tipo_usuario: null,
      usuarios: [],
      vista: 1,
      paginate: null,
      index_select: null,
      mostrar_filtros: false,
      agentes: [],
      agente: null,
      chart: {
        options: {
          plotOptions: {
            bar: {
              borderRadius: 10,
              distributed: true,
            },
          },
          legend: {
            show: false,
          },
          xaxis: {
            categories: ["Interesados", "Pendientes", "Exitosas"],
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          colors: ["#6296FE", "#FF4D4D", "#FFC100"],
        },
        series: [
          {
            name: "Usuarios",
            data: [0, 0, 0],
          },
        ],
      },
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    var page = localStorage.getItem("page_usuarios");
    if (page != undefined) {
      this.page = page;
      this.$router.push("/usuarios/" + page);
    } else {
      this.page = this.$route.params.page;
    }
    this.get_usuarios();
    this.get_agentes();
    this.get_resumen_clientes();
    var vista = localStorage.getItem("vista");
    if (vista != undefined) {
      this.vista = vista;
    }
  },
  methods: {
    get_usuarios: function () {
      this.loading_usuarios = true;
      var search = null;
      if (this.search != null && this.search.trim().length != 0) {
        search = this.search;
      }

      var page = 1;
      if (this.page != null && !isNaN(this.page)) {
        page = this.page;
      } else {
        this.$router.push("/usuarios/1");
      }

      localStorage.setItem("page_usuarios", page);
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      console.log(this.agente)
      let id_usuario = null;
      if (this.agente != null) {
        id_usuario = this.agente.id_usuario
      }
      let config = {
        headers: headers,
        params: {
          page: page,
          search: search,
          estado: this.estado,
          agente: id_usuario,
          tipo_membresia: this.tipo_membresia,
          tipo_usuario: this.tipo_usuario
        },
      };
      axios
        .get(this.$base_url + "clientes/clientes", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.usuarios = response.data.data.usuarios;
          this.get_paginate(response.data.data.total_pages);
          this.loading_usuarios = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_paginate: function (tpages) {
      var page = this.page;

      if (page === undefined || page <= 0) {
        this.page = 1;
        page = this.page;
      }

      var adjacents = 4;

      var paginate = null;

      paginate = '<ul class="pagination justify-content-center text-center">';
      // previous label
      if (page == 1) {
        paginate +=
          "<li class='paginate_button page-item previous disabled'><a class='page-link disabled'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      } else if (page == 2) {
        paginate +=
          "<li class='paginate_button page-item  previous'><a href='#/usuarios/1' class='page-link' href='javascript:void(0);'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      } else {
        var page_ant = parseFloat(page) - 1;
        paginate +=
          "<li class='paginate_button page-item'><a href='#/usuarios/" +
          page_ant +
          "' class='page-link' href='javascript:void(0);'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      }
      // first label
      if (page > parseFloat(adjacents) + 1) {
        paginate +=
          "<li class='paginate_button page-item'><a class='page-link' href='#/usuarios/1'>1</a></li>";
      }
      // interval
      if (page > parseFloat(adjacents) + 2) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // pages
      var pmin =
        page > adjacents ? parseFloat(page) - parseFloat(adjacents) : 1;
      var pmax =
        page < parseFloat(tpages) - parseFloat(adjacents)
          ? parseFloat(page) + parseFloat(adjacents)
          : tpages;

      for (var i = pmin; i <= pmax; i++) {
        if (i == page) {
          paginate +=
            "<li class='paginate_button page-item active'><a href='#/usuarios/" +
            i +
            "' class='page-link'>" +
            i +
            "</a></li>";
        } else if (i == 1) {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/usuarios/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        } else {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/usuarios/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        }
      }
      // interval
      if (page < parseFloat(tpages) - parseFloat(adjacents) - 1) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // last
      if (page < parseFloat(tpages) - parseFloat(adjacents)) {
        paginate +=
          "<li class='paginate_button page-item'><a  href='#/usuarios/" +
          tpages +
          "' class='page-link' href='javascript:void(0);'>" +
          tpages +
          "</a></li>";
      }
      // next
      if (page < tpages) {
        var page_next = parseFloat(page) + 1;
        paginate +=
          "<li class='paginate_button page-item next'><a  href='#/usuarios/" +
          page_next +
          "' class='page-link' href='javascript:void(0);'> <span aria-hidden='true'>&raquo;</span> </a></li>";
      } else {
        paginate +=
          "<li class='paginate_button page-item next disabled'><a class='page-link disabled'> <span aria-hidden='true'>&raquo;</span> </a></li>";
      }
      paginate += "</ul>";
      this.paginate = paginate;
    },
    get_resumen_clientes: function () {
      this.loading_chart = true;

      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "clientes/resumen_clientes", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.chart.series[0].data = response.data.data.chart;
          this.total_usuarios = response.data.data.total;
          this.loading_chart = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_search: function () {
      if (this.page != 1) {
        this.page = 1;
        this.$router.push("/usuarios/1");
      }
      this.get_usuarios();
    },
    get_agentes: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          agentes: 1,
        },
      };
      axios
        .get(this.$base_url + "admin/usuarios", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.agentes = response.data.data.usuarios;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    set_aliado: function () {
      this.loading = true;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {};
      axios
        .post(this.$base_url + "aliados/set_aliado", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
            return false;
          }
          vm.$router.push(
            "/aliado/info_basica/" + response.data.data.id_aliado
          );
          vm.loading = false;
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    show_modal_contrato: function (index) {
      this.index_select = index;
      this.$modal.show("modal_firma_contrato");
    },
    send_mail_contrato: function () {
      this.loading = true;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_usuario: this.usuarios[this.index_select].id_usuario,
      };
      axios
        .post(this.$base_url + "membresias/set_mail_contrato", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
            return false;
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Correo enviado",
              text: response.data.message,
            });
          }
          vm.get_usuarios();
          vm.loading = false;
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    download: function () {
      window.open(
        this.$base_url + "download/clientes/" + this.session.token,
        "_blank"
      );
    },
    show_modal_eliminar: function (index) {
      this.index_select = index;
      this.$modal.show("modal_eliminar");
    },
    eliminar: function () {
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_usuario: this.usuarios[this.index_select].id_usuario,
      };
      axios
        .post(this.$base_url + "clientes/eliminar_usuario", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Eliminado!",
              text: response.data.message,
            });
          }
          vm.index_select = null;
          vm.$modal.hide("modal_eliminar");
          vm.get_usuarios();
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    toggle_vista: function (vista) {
      this.vista = vista;
      localStorage.setItem("vista", this.vista);
    },
    toggle_filtros: function () {
      this.mostrar_filtros = !this.mostrar_filtros;
      localStorage.setItem("mostrar_filtros", this.mostrar_filtros);
    },
    filtrar: function () {
      if (this.page != 1) {
        this.page = 1;
        this.$router.push("/panel_aliados/1");
      }
      this.get_usuarios();
    },
  },
  mounted: function () {
    this.loading = false;
  },
  watch: {
    $route() {
      this.page = this.$route.params.page;
      this.get_usuarios();
    },
  },
};
</script>